import { ErrorMessages } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from '../rules/hideMenuRules';

const addToTarget = ({ coreApi, props }: BehaviorParameters) => {
  const target = coreApi.entities.findSelectedEntity();

  if (target) {
    const placementResult = coreApi.products.addToTarget(props.coreProductId, target);
    if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
      const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
        ? ErrorMessages.NoFramesInScene
        : ErrorMessages.ItemWontFit;
      coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
      coreApi.entities.disposeCollidingEntities(placementResult.errors);
    }
  }
};

export default addToTarget;
